export const CL_PRODUCT_COPY = {
  v1: {
    shortName: "Classic CL",
    liquidityTitle: "Classic CL Liquidity",
    poolTitle: "Classic CL Pool",
    createPoolTitle: "Create Classic CL Pool",
    createPositionTitle: "Create Classic CL Position",
    managePositionTitle: "Manage Classic CL Position",
    historyPositionTitle: "History - Classic CL Position",
    collectFeesTitle: "Collect Fees - Classic CL Position",
    closePositionTitle: "Close Classic CL Position",
    subtitle: "Classic CL · Concentrated liquidity",
  },
  v2: {
    shortName: "Dynamic CL",
    liquidityTitle: "Dynamic CL Liquidity",
    poolTitle: "Dynamic CL Pool",
    createPoolTitle: "Create Dynamic CL Pool",
    createPositionTitle: "Create Dynamic CL Position",
    managePositionTitle: "Manage Dynamic CL Position",
    historyPositionTitle: "History - Dynamic CL Position",
    collectFeesTitle: "Collect Fees - Dynamic CL Position",
    closePositionTitle: "Close Dynamic CL Position",
    subtitle: "Dynamic CL · Concentrated liquidity",
  },
} as const
